import React,{useState}from 'react'
import { Link } from 'react-router-dom'


const Register = () => {
    const[message,setmessage]=useState("")
    const[formData,setformData]=useState({
    name:"",
    email:"",
    password:"",
    password2:""
   })
const{name,email,password,password2}=formData
const onchange=e=>setformData({...formData,[e.target.name]:e.target.value})
const onsubmit=(e)=>{
    e.preventDefault()
    if(password!=password2){
        setmessage("Password do not match")
    }
}
  return (
    <section className="container">
      <h1 className="large text-primary">Sign Up</h1>
      <p className="lead"><i className="fas fa-user"></i> Create Your Account</p>
      <form className="form" onSubmit={e=>onsubmit(e)}>
        <div className="form-group">
          <input type="text" placeholder="Name" name="name" value={name} onChange={e=>onchange(e)}required />
        </div>
        <div className="form-group">
          <input type="email" placeholder="Email Address" name="email" value={email} onChange={e=>onchange(e)} />
        
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            name="password"
            minLength="6"
            value={password}
            onChange={e=>onchange(e)}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Confirm Password"
            name="password2"
            minLength="6"
            value={password2}
            onChange={e=>onchange(e)}
          />
        </div>
        <input type="submit" className="btn btn-primary" value="Register" />
      </form>
      <p className="my-1">
        Already have an account? <Link to="/login">Sign In</Link>
      </p>
      <div className="alert alert-danger" style={{display:message=="Password do not match"?"block":"none"}}>
        {message}
      </div>
    </section>
  )
}

export default Register
